import { gql } from '@apollo/client';
import {
  ASSESSMENT_DOMAINS_AND_SECTIONS,
  ASSESSMENT_IMPLEMENTATIONS,
} from 'graph/fragments/assessment';
import { ASSESSMENT_REPORT_BASE } from 'graph/fragments/assessment-report';

const GET_ASSESSMENT_REPORTS = gql`
  ${ASSESSMENT_IMPLEMENTATIONS}
  ${ASSESSMENT_DOMAINS_AND_SECTIONS}
  ${ASSESSMENT_REPORT_BASE}

  query AssessmentReports($where: AssessmentReportsWhereInput!) {
    assessmentReports(where: $where) {
      ...AssessmentReportBase
      assessment {
        ...AssessmentImplementations
        ...AssessmentDomainsAndSections
      }
    }
  }
`;

export default GET_ASSESSMENT_REPORTS;
